import { Show } from 'solid-js';
import DynamicModuleGenerator from '../../dynamic-module-generator';
import { Section } from '../../grid-system/section/section';
import { ErrorCatcher } from '../../tools/error-catcher';
import { SidebarPanel } from '../../ui-components/layouts/sidebar.style';
import { SidebarMenuDesktop } from '../sidebar/desktop/sidebar-menu-desktop';
import { SidebarMenuMobile } from '../sidebar/mobile/sidebar-menu-mobile';
import { Text } from '../../ui-components/text/text';
import { Column } from '../../grid-system/column/column';
import { Breadcrumb } from '../breadcrumb/breadcrumb';

type SidebarPageProps = {
    data: any;
    hasHero: boolean;
    mcRef?: string;
    isHcp: boolean;
};

export const SidebarPage = (props: SidebarPageProps) => {
    const content = () => {
        const blocks = props.data.content?.blocks;

        if (!props.hasHero) {
            return blocks;
        }

        if (blocks?.length < 2) {
            return blocks;
        }

        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const [hero, ...rest] = blocks;

        if (!rest) {
            return;
        }

        return rest;
    };

    const showBreadcrumb = () => !props.data.content?.disableBreadcrumbs
        && props.data.ancestryMeta?.length > 1;

    return (
        <ErrorCatcher componentName="SidebarPage">
            {/* Breadcrumb always renders above the hero in the nav region per rebrand plan —
                no more hero-conditional padding or mobile hiding. Component owns its own
                Section wrapper + top border so it looks attached to the header above. */}
            <Show when={showBreadcrumb()}>
                <Breadcrumb
                    pages={props.data.ancestryMeta}
                    url={props.data.content?.permalink}
                />
            </Show>
            <Show when={props.hasHero}>
                <DynamicModuleGenerator content={[props.data.content?.blocks[0]]} />
            </Show>
            {/* SidebarMenuMobile sits after the hero so the hero's pull-up (negative top margin on
                pages with hero, in page.tsx wrapper) doesn't hide the mobile sidebar accordion
                under the sticky header. */}
            <SidebarMenuMobile />
            <Section
                templateShorthand={[12]}
                widthType="bgFull"
                customCss={'padding-top: max(var(--spacing-cvi-section-close), var(--spacing-cvi-10)); padding-bottom: 0;'}
            >
                {/* Two-track grid, not a 12-column split — the gap
                    is a spacing token, not a gutter. See tailwind.css. */}
                <div class="sidebar-page-layout">
                    <SidebarPanel>
                        <SidebarMenuDesktop />
                    </SidebarPanel>
                    {/* Sections inside measure this column, not the viewport. */}
                    <div class="[container-type:inline-size]">
                        <div class="sidebar-page-content">
                            <Show when={content()}>
                                <article>
                                    <DynamicModuleGenerator
                                        content={content()}
                                        permalink={props.data.content?.permalink}
                                        pageTitle={props.data.content?.post_title}
                                    />
                                    <Show when={props.mcRef}>
                                        <Section
                                            templateShorthand={[ 10 ]}
                                            widthType='bgFull'
                                            isLayoutSection={false}
                                        >
                                            <Column>
                                                <Text fontSize='smaller'>
                                                    {props.mcRef}
                                                </Text>
                                            </Column>
                                        </Section>
                                    </Show>
                                </article>
                            </Show>
                        </div>
                    </div>
                </div>
            </Section>
        </ErrorCatcher>
    );
};
